import Vue from "vue";
import Raven from "raven-js";
import RavenVue from "raven-js/plugins/vue";

if (process.env.MIX_SENTRY_DSN) {
  Raven.config(process.env.MIX_SENTRY_DSN).addPlugin(RavenVue, Vue).install();
}
